import { Component, OnInit } from '@angular/core';
import confetti from 'canvas-confetti';
@Component({
  selector: 'app-ganadorso2',
  templateUrl: './ganadorso2.component.html',
  styleUrls: ['./ganadorso2.component.scss']
})
export class Ganadorso2Component implements OnInit {
 constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const duration = 2 * 1000;
    const end = Date.now() + duration;

    (function frame() {
      // Desde la izquierda
      confetti({
        particleCount: 10,
        angle: 60,
        spread: 100,
        origin: { x: 0, y: 0.5 }
      });
      // Desde la derecha
      confetti({
        particleCount: 10,
        angle: 120,
        spread: 100,
        origin: { x: 1, y: 0.5 }
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }

}
